import VATValidator from '../VATValidator'

export function taxIdIsValid(taxId: string): boolean {
  return VATValidator.isValid(taxId)
}

export function isIp(ip: string): boolean {
  const ipRegex = /^192\.168\.\d{1,3}\.\d{1,3}$/
  const ipRegex2 = /^10\.\d{1,3}\.\d{1,3}\.\d{1,3}$/
  const ipRegex3 = /^127\.0\.0\.1$/
  const ipRegex4 = /^172\.(1[6-9]|2[0-9]|3[0-1])\.\d{1,3}\.\d{1,3}$/

  const numbers = ip.split('.').map(Number)

  return (
    (ipRegex.test(ip) ||
      ipRegex2.test(ip) ||
      ipRegex3.test(ip) ||
      ipRegex4.test(ip)) &&
    numbers.every(number => number >= 0 && number <= 255)
  )
}

export function isUuid4(text: string): boolean {
  const uuidRegex =
    /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/

  return uuidRegex.test(text)
}

export function isEmail(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}
